import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'typed-values'
const verb = 'post'

export default class OspreyTypedValuePost extends BaseAction {
    constructor(dataKey) {
        const id = 'f1f2f7ad-a749-43f7-9600-b9e9efc12d82'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    createTypedValue(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/typed-value/typed-value-post.js